<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.593 20.7812L25.125 17.3125H21.7969V15.0625C21.7969 14.1135 22.2619 13.1875 23.7525 13.1875H25.2656V10.2344C25.2656 10.2344 23.8924 10 22.5795 10C19.8384 10 18.0469 11.6613 18.0469 14.6688V17.3125H15V20.7812H18.0469V29.1667C19.2893 29.3611 20.5544 29.3611 21.7969 29.1667V20.7812H24.593Z"
      fill="currentColor"
    />
    <rect
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="currentColor"
    />
  </svg>
</template>
